import { render, staticRenderFns } from "./SSSalonDashboardView.vue?vue&type=template&id=1953a830&scoped=true&"
import script from "./SSSalonDashboardView.vue?vue&type=script&lang=js&"
export * from "./SSSalonDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./SSSalonDashboardView.vue?vue&type=style&index=0&id=1953a830&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953a830",
  null
  
)

export default component.exports